<div class="snack-bar" [ngClass]="'snack-bar--' + type">
    <nw-icon class="snack-bar__icon" [icon]="icon"></nw-icon>
    <div class="snack-bar__message">
        <ng-content select="[snack-bar-message]"></ng-content>
    </div>
    <div class="snack-bar__action">
        <ng-content select="[snack-bar-actions]"></ng-content>
    </div>
</div>
